import React from 'react';

import Banner from './Banner';
import Collaborate from './Collaborate';
import Products from './Products';

const Product:React.FC = () => (
  <>
    <Banner />
    <Products />
    <Collaborate />
  </>
  );

export default Product;
